"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));

var _excluded = ["value", "id", "name", "label", "floatLabel", "placeholder", "helper", "required", "disabled", "readOnly", "onChange", "onFocus", "onBlur", "hasError", "onError", "className", "addon", "addonPosition", "labelAria", "withErrorTooltip", "icon", "iconPosition", "customMessage"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CustomInput = /*#__PURE__*/_react.default.forwardRef(function (inputProps, ref) {
  return /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: ref,
    className: "uk-inputtable",
    type: "number"
  }, inputProps));
});
/**
 * The InputPhone component allows an user to enter an auto-formatted phone number into the application.
 */


var InputPhone = function InputPhone(props) {
  var controlledValue = props.value,
      id = props.id,
      name = props.name,
      initialLabel = props.label,
      floatLabel = props.floatLabel,
      placeholder = props.placeholder,
      helper = props.helper,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      hasError = props.hasError,
      onError = props.onError,
      className = props.className,
      addon = props.addon,
      addonPosition = props.addonPosition,
      labelAria = props.labelAria,
      withErrorTooltip = props.withErrorTooltip,
      icon = props.icon,
      iconPosition = props.iconPosition,
      customMessage = props.customMessage,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var inputRef = _react.default.useRef(null);

  var _React$useState = _react.default.useState({
    tel: controlledValue || '',
    ext: ''
  }),
      value = _React$useState[0],
      setValue = _React$useState[1];

  var _React$useState2 = _react.default.useState(hasError),
      error = _React$useState2[0],
      setError = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      focus = _React$useState3[0],
      setFocus = _React$useState3[1];

  var _useFormElementValida = (0, _useFormElementValidation.default)(value, {
    required: required,
    tel: true,
    customMessage: customMessage
  }),
      errors = _useFormElementValida[0],
      methods = _useFormElementValida[1];

  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
    id: id,
    value: value.tel
  })),
      label = _useLabel.label;

  _react.default.useEffect(function () {
    return setValue({
      tel: controlledValue || ''
    });
  }, [controlledValue]);

  _react.default.useEffect(function () {
    setError(errors.length > 0);

    if (typeof onError === 'function') {
      onError({
        name: inputRef.current.name,
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError]);

  var handleFocus = function handleFocus() {
    setFocus(true);

    if (typeof onFocus === 'function') {
      onFocus(inputRef.current.value);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocus(false);
    methods.onBlur(event);

    if (typeof onBlur === 'function') {
      onBlur(inputRef.current.value);
    }
  };

  var handleValueChange = function handleValueChange(valueObject) {
    setValue(_extends({}, value, {
      tel: valueObject.value
    }));
    methods.onChange(valueObject.value); // Only trigger when the user has the focus on it

    if (focus && typeof onChange === 'function') {
      onChange(valueObject.floatValue);
    }
  };

  var handleChange = function handleChange(event) {
    if (addon === 'extension') {
      var extValue = event.target.value;

      if (extValue.length <= 6) {
        setValue(_extends({}, value, {
          ext: extValue
        }));
      }
    }
  };

  var containerClasses = (0, _clsx.default)('uk-form-item', 'uk-input', 'uk-input--phone', (icon == null ? void 0 : icon.length) && 'has-icon', (icon == null ? void 0 : icon.length) && "has-icon--" + iconPosition, // addon && 'has-extension',
  // addon && `has-extension--${addonPosition}`,
  addon && 'has-info', addon && "has-info--" + addonPosition, helper.length > 0 || error ? 'has-helper' : '', error ? 'has-error' : '', errors.length > 0 && withErrorTooltip && 'has-error--tooltip', (error || disabled || readOnly) && 'is-frozen', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-input__field"
  }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, _extends({
    getInputRef: inputRef,
    id: id,
    name: name || id,
    value: value.tel,
    placeholder: placeholder && !floatLabel ? placeholder : null,
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    format: "(###) ###-####",
    isNumericString: true,
    onValueChange: handleValueChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    customInput: CustomInput,
    "aria-describedby": (name || id) + "-helper-text " + (name || id) + "-required-message",
    "aria-errormessage": (name || id) + "-helper-text",
    "aria-invalid": error
  }, attributes)), icon && icon.length && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: (0, _clsx.default)('uk-input__icon', iconPosition),
    name: icon
  }), errors.length > 0 && withErrorTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    trigger: "!",
    className: "uk-form-item__error-tooltip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: (name || id) + "-errors-text"
  }, errors))), addon && /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    name: "work-phone-extension",
    className: "uk-inputtable__addon uk-inputtable__addon--phone " + addonPosition,
    placeholder: "Ext",
    disabled: disabled,
    defaultValue: value.ext,
    onChange: handleChange
  })), errors.length > 0 && !withErrorTooltip && /*#__PURE__*/_react.default.createElement("span", {
    className: "uk-form-item__error",
    id: (name || id) + "-errors-text"
  }, errors), errors.length > 0 && !withErrorTooltip ? '' : helper.length > 0 && /*#__PURE__*/_react.default.createElement("small", {
    className: "uk-form-item__helper",
    id: (name || id) + "-helper-text"
  }, helper));
};

InputPhone.propTypes = {
  /**
   * Default value of the input
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Mandatory ID of the input
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Used instead of the ID when submitted
   */
  name: _propTypes.default.string,

  /**
   * Label of the input
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * Native input placeholder
   */
  placeholder: _propTypes.default.string,

  /**
   * Remove the placeholder if any, replace it by a floating label
   */
  floatLabel: _propTypes.default.bool,

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Set the input as required
   */
  required: _propTypes.default.bool,

  /**
   * Set the input as read-only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Disable the input
   */
  disabled: _propTypes.default.bool,

  /**
   * Display input to allow write a telephone extension
   */
  addon: _propTypes.default.bool,

  /**
   * Position the info relative to the input element
   */
  addonPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onFocus
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function onBlur
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,

  /**
   * Add an icon
   */
  icon: _propTypes.default.string,

  /**
   * Position the icon relative to the input element
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string,

  /**
   * Display error in tooltip otherwise display error below input.
   */
  withErrorTooltip: _propTypes.default.bool,

  /**
   * Write a custom message when validation triggered an error
   */
  customMessage: _propTypes.default.string
};
InputPhone.defaultProps = {
  required: false,
  readOnly: false,
  disabled: false,
  floatLabel: false,
  placeholder: '',
  helper: '',
  withErrorTooltip: true,
  addon: false,
  icon: '',
  iconPosition: 'right',
  addonPosition: 'right'
};
var _default = InputPhone;
exports.default = _default;